"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
// Vue components
const BuildingInfo_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BuildingInfo.vue"));
const MetricsTool_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/MetricsTool.vue"));
const MetricPlot_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/MetricPlot.vue"));
const VariationRanking_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/VariationRanking.vue"));
const Zero_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/Zero.vue"));
const ClusterEditor_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/ClusterEditor.vue"));
const Parcel_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/Parcel"));
const Info_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/Info"));
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
const trans_1 = require("@common/tsutils/trans");
const TestBoxPlotEvolutionAPI_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/TestBoxPlotEvolutionAPI.vue"));
const BoxPlotNavigation_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/BoxPlotNavigation.vue"));
const BoxPlotEvolution_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/models/evolution/BoxPlotEvolution"));
const STAGES = [
    'zero',
    'loading1',
    'clusters',
    'zero',
    'loading2',
    'ranking',
    'boxplot',
];
let MainViewMetricsBoxPlot = class MainViewMetricsBoxPlot extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.parcels = null;
        this.clusters = null;
        this.density = null;
        this.metrics = [];
        this.beforeClustersInfo = null;
        this.afterClustersInfo = null;
        // loading1 -> clusters -> loading2 -> tool
        this.stage = 'loading1';
        this.metricSelected = '';
        this.metricPlotSelected = null;
        this.bpe = new BoxPlotEvolution_1.default();
        this.hasSamplesWithoutRawRank = false;
        this.categoryElement = 'all';
    }
    open() {
        const modal = this.$refs.modal;
        modal.open();
    }
    created() {
        this.beforeClustersInfo = new Info_1.default({
            title: (0, trans_1.trans)('toolkit.clusters.fetching'),
            subtitle: (0, trans_1.trans)('toolkit.clusters.fetching__sub'),
            emphatizer: (0, trans_1.trans)('toolkit.clusters.fetching__emp'),
        });
        this.afterClustersInfo = new Info_1.default({
            title: (0, trans_1.trans)('toolkit.coocurrence.creating.title'),
            subtitle: (0, trans_1.trans)('toolkit.coocurrence.creating.subtitle'),
            emphatizer: (0, trans_1.trans)('toolkit.coocurrence.creating.emphatize'),
        });
    }
    get hasPhch() {
        return true;
    }
    mounted() {
        this.loadParcels();
    }
    setStage(newStage) {
        this.stage = newStage;
    }
    updateDimension(newDimension) {
        this.bpe.setDimension(newDimension);
    }
    get isPhchDimension() {
        return this.bpe.isPhchDimension;
    }
    get dimension() {
        return this.bpe.dimension;
    }
    async loadParcels() {
        this.parcels = await Parcel_1.default.all({
            add_raw_rank_flag: true,
            add_sample_location: true,
        });
        await (0, sleep_1.default)(2300);
        if (this.parcels && this.parcels.length) {
            this.stage = 'clusters';
            for (const p of this.parcels) {
                for (const s of p.samples) {
                    if (this.boxPlotSampleDisabledFn(s)) {
                        this.hasSamplesWithoutRawRank = true;
                        break;
                    }
                }
            }
        }
        else {
            this.stage = 'zero';
        }
    }
    /*     @Watch('dimension')
    async callPhchData() {
        this.bpe.setDimension(this.dimension);
    } */
    async onClusters(clusters) {
        this.stage = 'loading2';
        this.bpe = new BoxPlotEvolution_1.default();
        this.bpe.setClusters(clusters.clusters[0], clusters.clusters[1]);
        this.clusters = clusters;
        await this.bpe.load();
        this.categoryElement = 'all';
        this.stage = 'ranking';
    }
    switchStageInNav(id) {
        this.stage = id;
    }
    launchPlot(m) {
        this.metricSelected = m.name;
        this.metricPlotSelected = m;
        this.stage = 'boxplot';
    }
    boxPlotSampleDisabledFn(sample) {
        return !sample.has_raw_ranks;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MainViewMetricsBoxPlot.prototype, "map_config", void 0);
MainViewMetricsBoxPlot = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            BuildingInfo: BuildingInfo_vue_1.default,
            ClusterEditor: ClusterEditor_vue_1.default,
            VariationRanking: VariationRanking_vue_1.default,
            MetricPlot: MetricPlot_vue_1.default,
            MetricsTool: MetricsTool_vue_1.default,
            Zero: Zero_vue_1.default,
            TestBoxPlotEvolutionAPIVue: TestBoxPlotEvolutionAPI_vue_1.default,
            BoxPlotNavigation: BoxPlotNavigation_vue_1.default,
        },
    })
], MainViewMetricsBoxPlot);
exports.default = MainViewMetricsBoxPlot;
